// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.form .form-field p {
    margin-bottom: 12px;
    font-size: 17px;
    color: #43425D;
}
*/

.aud-tabs .panel .btn{background:#f8f8f8; color:#9f9eac; border-radius:6px 6px 0 0; font-size:14px; margin-right:2px; padding:15px 26px; border:#e9e9f0 solid 1px; border-bottom:none;}
.aud-tabs .panel .btn.active{background:#3b86ff; color:#fff;}
.aud-tabs .panel.border-panel{border-bottom:#e9e9f0 solid 1px;}

.summary-list, .yourwebsite-tab { color:#43425D;}
.summary-list h5, .yourwebsite-tab  h5{ font-size:17px; border-bottom:1px solid #D3D3D3; padding-bottom:10px;} 
.yourwebsite-tab .col-sm-12{line-height:26px;}
.summary-list label{font-weight:700; margin-bottom:0;}
.summary-list label+div{font-style:italic; padding-left:4px;}
.summary-list h4{border-bottom:#4d4f5c solid 4px; font-weight:700; font-size:20px;}
.summary-list ul{margin-bottom:0;}
.summary-list ul li{font-style:italic;}
.btn-secondary:not(:disabled):not(.disabled):active{box-shadow:none; background:#fff; color:#ADADAD; border:1px solid #D3D3D3;}
.listing-border {
    border: #D1D3DB solid 1px !important;
}
.heading-style-5 {
    background: #F5F6FA;
    padding: 0 20px;
    border-bottom: #D3D3D3 solid 1px;
}
.heading-style-5 h3 {
    color: #4D4F5C;
    font-size: 19px;
    line-height: 46px;
    font-weight: 700;
	margin:0;}
.blue-text {
    color: #3597EC !important;
}
.flex-one-half{flex-basis:49%;}

.icon {
    display: inline-block;
    height: 28px;
    flex-basis: 28px;
    min-width: 28px;
}
.icon.eye{background-image:url(/assets/images/eye-icon.svg);}
.icon.cross-delete{background-image:url(/assets/images/cross-delete.svg);}
.theme-bg {
    background: #303E4E !important;
}




/* .review-submit {
    background: #323E4A url(/assets/images/final-review-arow.png) no-repeat 32px bottom;
    min-height: 170px;
}
.white-text {
    color: #fff !important;
}

.ml-140 {
    margin-left: 140px !important;
}
.font-22 {
    font-size: 22px !important;
}

.flex-200 {
    flex-basis: 200px !important;
    min-width: 200px;
} */`, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/basic/review/review.component.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED,sBAAsB,kBAAkB,EAAE,aAAa,EAAE,yBAAyB,EAAE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,CAAC;AACtL,6BAA6B,kBAAkB,EAAE,UAAU,CAAC;AAC5D,8BAA8B,+BAA+B,CAAC;;AAE9D,kCAAkC,aAAa,CAAC;AAChD,wCAAwC,cAAc,EAAE,+BAA+B,EAAE,mBAAmB,CAAC;AAC7G,4BAA4B,gBAAgB,CAAC;AAC7C,oBAAoB,eAAe,EAAE,eAAe,CAAC;AACrD,wBAAwB,iBAAiB,EAAE,gBAAgB,CAAC;AAC5D,iBAAiB,+BAA+B,EAAE,eAAe,EAAE,cAAc,CAAC;AAClF,iBAAiB,eAAe,CAAC;AACjC,oBAAoB,iBAAiB,CAAC;AACtC,oDAAoD,eAAe,EAAE,eAAe,EAAE,aAAa,EAAE,wBAAwB,CAAC;AAC9H;IACI,oCAAoC;AACxC;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;CACnB,QAAQ,CAAC;AACV;IACI,yBAAyB;AAC7B;AACA,eAAe,cAAc,CAAC;;AAE9B;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA,UAAU,iDAAiD,CAAC;AAC5D,mBAAmB,qDAAqD,CAAC;AACzE;IACI,8BAA8B;AAClC;;;;;AAKA;;;;;;;;;;;;;;;;;;GAkBG","sourcesContent":["/*.form .form-field p {\n    margin-bottom: 12px;\n    font-size: 17px;\n    color: #43425D;\n}\n*/\n\n.aud-tabs .panel .btn{background:#f8f8f8; color:#9f9eac; border-radius:6px 6px 0 0; font-size:14px; margin-right:2px; padding:15px 26px; border:#e9e9f0 solid 1px; border-bottom:none;}\n.aud-tabs .panel .btn.active{background:#3b86ff; color:#fff;}\n.aud-tabs .panel.border-panel{border-bottom:#e9e9f0 solid 1px;}\n\n.summary-list, .yourwebsite-tab { color:#43425D;}\n.summary-list h5, .yourwebsite-tab  h5{ font-size:17px; border-bottom:1px solid #D3D3D3; padding-bottom:10px;} \n.yourwebsite-tab .col-sm-12{line-height:26px;}\n.summary-list label{font-weight:700; margin-bottom:0;}\n.summary-list label+div{font-style:italic; padding-left:4px;}\n.summary-list h4{border-bottom:#4d4f5c solid 4px; font-weight:700; font-size:20px;}\n.summary-list ul{margin-bottom:0;}\n.summary-list ul li{font-style:italic;}\n.btn-secondary:not(:disabled):not(.disabled):active{box-shadow:none; background:#fff; color:#ADADAD; border:1px solid #D3D3D3;}\n.listing-border {\n    border: #D1D3DB solid 1px !important;\n}\n.heading-style-5 {\n    background: #F5F6FA;\n    padding: 0 20px;\n    border-bottom: #D3D3D3 solid 1px;\n}\n.heading-style-5 h3 {\n    color: #4D4F5C;\n    font-size: 19px;\n    line-height: 46px;\n    font-weight: 700;\n\tmargin:0;}\n.blue-text {\n    color: #3597EC !important;\n}\n.flex-one-half{flex-basis:49%;}\n\n.icon {\n    display: inline-block;\n    height: 28px;\n    flex-basis: 28px;\n    min-width: 28px;\n}\n.icon.eye{background-image:url(/assets/images/eye-icon.svg);}\n.icon.cross-delete{background-image:url(/assets/images/cross-delete.svg);}\n.theme-bg {\n    background: #303E4E !important;\n}\n\n\n\n\n/* .review-submit {\n    background: #323E4A url(/assets/images/final-review-arow.png) no-repeat 32px bottom;\n    min-height: 170px;\n}\n.white-text {\n    color: #fff !important;\n}\n\n.ml-140 {\n    margin-left: 140px !important;\n}\n.font-22 {\n    font-size: 22px !important;\n}\n\n.flex-200 {\n    flex-basis: 200px !important;\n    min-width: 200px;\n} */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
